<template>
  <form class="nx-form" :data-vv-scope="scope" :id="'scope-' + scope"
        :class="{'nx-active' :active}">
    <h2 v-if="scope" class="nx-form-legend">{{ $t('message.form.scopes.' + scope) }}</h2>
    <div class="nx-form-fieldset">
      <nx-content-taxonomy-form-selector
          :content-id="contentId"
          :disabled="disabled"
          :label="$t('message.form.fields.mainTaxonomyId')"
          :limit="1"
          :type="['section', 'microsite']"
          :value="draft.mainTaxonomyId"
          @authorized="onAuthorized"
          name="mainTaxonomyId"
          validation="required">
      </nx-content-taxonomy-form-selector>
      <nx-content-taxonomy-form-selector
          :content-id="contentId"
          :disabled="disabled"
          :label="$t('message.form.fields.secondaryTaxonomyIds')"
          :limit="10"
          :type="['section', 'microsite']"
          :value="draft.secondaryTaxonomyIds"
          @authorized="onAuthorized"
          name="secondaryTaxonomyIds">
      </nx-content-taxonomy-form-selector>
      <nx-content-tag-form-selector
          :content-id="contentId"
          :disabled="disabled"
          :label="$t('message.form.fields.tagIds')"
          :limit="10"
          :value="draft.tagIds"
          @authorized="onAuthorized"
          name="tagIds">
      </nx-content-tag-form-selector>
    </div>
  </form>
</template>

<script>
import FormScope from '@/modules/form/FormScope';
import TaxonomySelector from '@/modules/content/taxonomy/TaxonomyFormSelector';
import TagSelector from '@/modules/content/taxonomy/TagFormSelector';
import toast from '@/modules/toast/services';

export default {
  name: 'nx-form-content-cataloging',
  extends: FormScope,
  components: {
    [TaxonomySelector.name]: TaxonomySelector,
    [TagSelector.name]: TagSelector,
  },
  computed: {
    contentId() {
      return this.$route.params.id;
    },
  },
  methods: {
    onAuthorized(value) {
      // TODO: set taxonomy fieldvalidation to false
      if (!value) {
        toast.notify('message.error.forbidden');
      }
    },
  },
};
</script>
